import { useEffect } from 'react'
import { Navigate, useNavigate } from 'react-router-dom'
import { ScreenTransition } from '@/components/ScreenTransition'
import { useQuiz } from '@/state/QuizContext'

/**
 * Screen between Finish and Result. In Phase 3 this is a timed bridge so the
 * user sees the brand loading moment; in Phase 4 we'll replace the timeout
 * with a real submission promise (Netlify function → Blobs + Klaviyo event).
 *
 * Copy below is placeholder - Maria to approve the final wording.
 */
export function LoadingScreen() {
  const { isComplete } = useQuiz()
  const navigate = useNavigate()

  // Defensive redirect - if someone opens /loading directly without completing
  // the quiz, bounce them to the start. (Navigate in render is OK inside StrictMode.)
  if (!isComplete) return <Navigate to="/" replace />

  useEffect(() => {
    const t = window.setTimeout(() => navigate('/result', { replace: true }), 3000)
    return () => window.clearTimeout(t)
  }, [navigate])

  return (
    <ScreenTransition className="fq-loading">
      <div className="fq-stack fq-stack--loading">
        <div className="fq-spinner" aria-hidden="true" />
        <p className="fq-h4">Finding your dream pants…</p>
        <p className="fq-footnote">One moment - we're matching your answers to the right style.</p>
      </div>
    </ScreenTransition>
  )
}
